var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { keyframes, styled } from '@mui/material';
var rotateAnimation = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"], ["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"])));
var StyledSvg = styled('svg')({
    animation: "".concat(rotateAnimation, " 1.5s linear infinite")
});
var AlertLoadingIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 28 : _c, _d = _a.color, color = _d === void 0 ? 'white' : _d, rest = __rest(_a, ["width", "height", "color"]);
    return (_jsx(StyledSvg, __assign({ width: width, height: height, viewBox: '0 0 24 28', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', style: {
            animation: "".concat(rotateAnimation, " 1.5s linear infinite")
        } }, rest, { children: _jsx("path", { d: 'M15.6944 1.16641L16.392 2.47048C16.8637 3.35212 17.0995 3.79294 16.9436 3.98173C16.7876 4.17052 16.2741 4.01805 15.2469 3.71311C14.22 3.40823 13.1297 3.24419 12 3.24419C5.8788 3.24419 0.916626 8.05962 0.916626 13.9997C0.916626 15.9588 1.45635 17.7955 2.39938 19.3775M8.30551 26.8331L7.60788 25.529C7.13622 24.6474 6.90039 24.2065 7.05633 24.0178C7.21227 23.829 7.72587 23.9814 8.753 24.2864C9.7799 24.5913 10.8702 24.7553 12 24.7553C18.1211 24.7553 23.0833 19.9399 23.0833 13.9997C23.0833 12.0407 22.5436 10.204 21.6005 8.62197', stroke: color, "stroke-width": '1.5', "stroke-linecap": 'round', "stroke-linejoin": 'round' }) })));
};
export default AlertLoadingIcon;
var templateObject_1;
